<section class="py-3">
  <div class="container-fluid card inner-scroll">
    <h3 class="text strat pt-3">Return from Customer</h3>
    <form (ngSubmit)="onSubmit()" [formGroup]="returnToCustomerForm">
      <div class="row pt-3 g-3">
        @if (userDetails?.enrollmentType === "Company") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="toBranchSelect">To Branch <span class="text-danger">*</span></label>
          <ng-select labelForId="toBranchSelect" [items]="filteredActiveBranches" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="true" [searchable]="true" placeholder="Select To Branch" [readonly]="showStockArray"
            formControlName="toBranch" class="ng-select-bootstrap" appendTo="body" (change)="onBranchChange()">
          </ng-select>
        </div>
        }
        <div class="col-12 col-sm-6 col-md-3">
          <label for="invoiceNumber">Invoice Number <span class="text-danger">*</span></label>
          <input formControlName="invoiceNumber" id="invoiceNumber" type="text" [readonly]="showStockArray"
            class="form-control default-form-group-border" placeholder="Invoice number" required maxlength="20"
            (input)="onInvoiceInput($event)" (change)="onInvoiceChange($event)" />
          @if (
          returnToCustomerForm.get("invoiceNumber")?.invalid &&
          returnToCustomerForm.get("invoiceNumber")?.touched
          ) {
          <div>
            @if (returnToCustomerForm.get("invoiceNumber")?.errors?.['required']) {
              <small class="text-danger">Please enter invoice number</small>
            }
            @if (returnToCustomerForm.get("invoiceNumber")?.errors?.['minlength']) {
              <small class="text-danger">Invoice number must be at least 3 characters</small>
            }
            @if (returnToCustomerForm.get("invoiceNumber")?.errors?.['maxlength']) {
              <small class="text-danger">Invoice number must be at most 30 characters</small>
            }
          </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="customerPhoneInput">Phone Number <span class="text-danger">*</span></label>
          <input id="customerPhoneInput" class="form-control no-spinner default-form-group-border" type="number" formControlName="customerPhone"
            name="customerPhone" required placeholder="Phone number" [appMaxLength]="10" (input)="onInput($event)" [readonly]="showStockArray"/>
          @if (
          returnToCustomerForm.get("customerPhone")?.invalid &&
          returnToCustomerForm.get("customerPhone")?.touched
          ) {
          <div>
            <small class="text-danger">Please enter valid phone number</small>
          </div>
          }
        </div>
      </div>

      @if (showStockArray) {
      <div class="mt-4 pt-2 border-top">
        <h4 class="mb-3">Stock Items</h4>
        @for (item of stock.controls; track item; let i = $index) {
        <div formArrayName="stock">
          <div class="row g-3 border-bottom pb-4 mb-2" [formGroupName]="i">
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'tyreSizeSelect_' + i">Tyre Size<span class="text-danger">*</span></label>
              <ng-select [labelForId]="'tyreSizeSelect_' + i" [items]="tyreSizeObj.list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
                [clearable]="!isFromInvoice" [searchable]="!isFromInvoice" [readonly]="isFromInvoice" placeholder="Search or Select Tyre Size"
                formControlName="tyreSize" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
                (scrollToEnd)="onScrollTyreSize()" (search)="onTyreSizeInputChange($event)"
                (close)="onSizeClose()" (clear)="onSizeClose()">
              </ng-select>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'tyreMakeSelect_' + i">Tyre Make<span class="text-danger">*</span></label>
              <ng-select [labelForId]="'tyreMakeSelect_' + i" [items]="tyreMakeObj.list" [multiple]="false"
                [clearable]="!isFromInvoice" [searchable]="!isFromInvoice" [readonly]="isFromInvoice" placeholder="Search or Select Tyre Make"
                formControlName="tyreMake" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
                (change)="selectMake($event, i)" (search)="onTyreMakeInputChange($event)"
                (close)="onMakeClose()" (clear)="onMakeClose()">
              </ng-select>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'tyreModelSelect_' + i">Tyre Model<span class="text-danger"></span></label>
              <ng-select [labelForId]="'tyreModelSelect_' + i" [items]="tyreModelList[i].list" bindLabel="name" bindValue="name" [multiple]="false"
                [clearable]="!isFromInvoice" [searchable]="!isFromInvoice" placeholder="Search or Select Tyre Model"
                formControlName="tyreModel" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
                [readonly]="isFromInvoice || !stock.at(i).get('tyreMake')?.value"
                (scrollToEnd)="scroll(i)" (search)="onTyreModelInputChange($event, i)"
                (close)="onModelClose(i)" (clear)="onModelClose(i)">
              </ng-select>
            </div>
            <div class="col-6 col-sm-6 col-md-3">
              <label [attr.for]="'quantityInput_' + i">Quantity <span class="text-danger">*</span></label>
              <input [id]="'quantityInput_' + i" type="number" class="form-control no-spinner default-form-group-border" formControlName="quantity"
                name="quantity" required placeholder="Qty" appBlockNumberSpecialchars [extraChars]="['.']" />
              @if (
              stock.at(i).get("quantity")?.invalid &&
              stock.at(i).get("quantity")?.touched
              ) {
              <div>
                @if (stock.at(i).get("quantity")?.errors?.['max']) {
                  <small class="text-danger">Max: {{ stock.at(i).get("quantity")?.errors?.['max']?.max }}</small>
                } @else {
                  <small class="text-danger">Required</small>
                }
              </div>
              }
            </div>
            <div class="col-6 col-sm-6 col-md-3">
              <label [attr.for]="'purchasingPriceInput_' + i">Tyre Price <span class="text-danger">*</span></label>
              <input [id]="'purchasingPriceInput_' + i" type="number" class="form-control no-spinner default-form-group-border" formControlName="purchasingPrice"
                name="purchasingPrice" required placeholder="Price" appBlockNumberSpecialchars/>
              @if (
              stock.at(i).get("purchasingPrice")?.invalid &&
              stock.at(i).get("purchasingPrice")?.touched
              ) {
              <div>
                @if (stock.at(i).get("purchasingPrice")?.errors?.['max']) {
                  <small class="text-danger">Max: {{ stock.at(i).get("purchasingPrice")?.errors?.['max']?.max }}</small>
                } @else {
                  <small class="text-danger">Required</small>
                }
              </div>
              }
            </div>
            <div class="col-6 col-sm-6 col-md-3 d-flex align-items-end justify-content-start gap-1">
                @if (i == stock.length - 1 && !isFromInvoice) {
                <button class="btn app-btn-primary" type="button" (click)="addItem(i)">
                  <fa-icon [icon]="faPlus"></fa-icon>
                </button>
                }
                @if (stock.length > 1) {
                <button class="btn btn-danger" type="button" (click)="removeItem(i)">
                  <fa-icon [icon]="faTrash"></fa-icon>
                </button>
                }
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Payment Details Section -->
      <div class="mt-4 pt-2 border-top">
        <h4 class="mb-3">Payment Details</h4>
        <div class="row g-3">
          <div class="col-12 col-sm-6 col-md-3">
            <label for="totalAmountInput">Total Amount</label>
            <input id="totalAmountInput" type="number" class="form-control default-form-group-border" [value]="totalAmount" readonly disabled />
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label for="paymentModeSelect">Payment Mode <span class="text-danger">*</span></label>
            <ng-select labelForId="paymentModeSelect" [items]="paymentModes" bindLabel="label" bindValue="value" [multiple]="false"
              [clearable]="false" placeholder="Select Payment Mode" formControlName="paymentMode"
              class="ng-select-bootstrap" appendTo="body" (change)="loadPaymentAccounts()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label for="paymentAccountSelect">Payment Account <span class="text-danger">*</span></label>
            <ng-select labelForId="paymentAccountSelect" [items]="paymentAccountsList" bindLabel="accountName" bindValue="_id" [multiple]="false"
              [clearable]="false" placeholder="Select Payment Account" formControlName="paymentAccount"
              [loading]="paymentAccountsLoading" class="ng-select-bootstrap" appendTo="body">
            </ng-select>
          </div>
        </div>
      </div>
      }

      <div class="text-danger pt-3">{{ resMsg }}</div>
      <div class="row pt-3">
        <div class="col-12 text-end p-3">
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/product-list'" [disabled]="isLoading">
            Cancel
          </button>
          <button type="submit" [disabled]="(showStockArray ? returnToCustomerForm.invalid : (returnToCustomerForm.get('toBranch')?.invalid || returnToCustomerForm.get('invoiceNumber')?.invalid || returnToCustomerForm.get('customerPhone')?.invalid)) || isLoading" class="btn app-btn-primary">
            {{ showStockArray ? 'Submit' : 'Next' }}
            @if (isLoading) {
             <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
            }
          </button>
        </div>
      </div>
    </form>
  </div>
</section>